import useGoBack from 'utilities/navigation/back'
import { Field, Form, Formik } from 'formik'
import Header from 'components/headers/addLoan'
import AddNewIcon from 'assets/images/loans/managementAddNew.svg'
import Num2persian from 'utilities/helper/num2Persian'
import { useState } from 'react'
import CustomDatePicker from 'components/datePicker'
import useGetCards from 'pages/loans/withDraw/hooks/useGetCards'
import { toast } from 'react-toastify'
import { useLocation, useParams } from 'react-router-dom'
import SelectModal from 'components/modals/selectModal'
import FeeModal from 'components/modals/feeModal'
import { Schema } from './utilities'
import posthog from 'posthog-js'
import moment from 'jalali-moment'
import { getOneMonthLater } from 'utilities/helper/getOneMonthLater'
import { loanInterestFields } from 'utilities/helper/loanInterest'
import useSetNewLoans from '../../addNew/hooks/useSetNewLoans'
import useSetOldLoans from '../hooks/useSetOldLoans'
import { NumericFormat } from 'react-number-format'

interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}
export default function AddOldStepOne() {
    const [isOpenReceiver, setIsOpenReceiver] = useState<boolean>(false)
    const [selectedUser, setSelectedUser] = useState<ISelectUser>()
    const [isOpenFeeModal, setIsOpenFeeModal] = useState<boolean>(false)
    const [selectedFee, setSelectedFee] = useState<number | undefined>(0)
    const [selectedFeeType, setSelectedFeeType] = useState<string>('percentage')
    const [isOpenWalletModal, setIsOpenWalletModal] = useState<boolean>(false)
    const [selectedBankNumber, setSelectedBankNumber] = useState<number>(0)
    const [memberId, setMemberId] = useState<undefined | number>()
    const goBack = useGoBack()
    const params = useParams()
    const { state } = useLocation()
    const {
        data,
        isLoading,
        activeAccount,
        activeAccounts,
        otherAccounts,
        handleSelectCard,
        reallySelectedCard,
    } = useGetCards(
        selectedUser?.id,
        selectedUser?.memberId,
        setSelectedBankNumber
    )
    const { mutate } = useSetOldLoans()
    return (
        <>
            <Formik
                initialValues={{
                    amount: '',
                    tag: '',
                    number: '',
                    fee_type: '',
                    date: '',
                    paid_loans: '',
                }}
                validationSchema={Schema}
                onSubmit={(values) => {
                    if (Number(values.amount) >= 5000) {
                        if (selectedUser) {
                            if (
                                selectedFee !== undefined &&
                                selectedFee !== null
                            ) {
                                if (selectedFee === 0) {
                                    values.fee_type = 'lip_ma'
                                }
                                if (values.fee_type.length > 0) {
                                    if (
                                        Number(values.number) >
                                        Number(values.paid_loans)
                                    ) {
                                        const data: IManagementBodyFirstOld = {
                                            moneyPool: params?.id,
                                            poolShip: selectedUser.id,
                                            amount: values.amount,
                                            tag: values.tag,
                                            number_of_repaid_installments:
                                                values.paid_loans,
                                            number_of_repayments: values.number,
                                            bank_account:
                                                reallySelectedCard &&
                                                reallySelectedCard.id,
                                            bankName:
                                                reallySelectedCard &&
                                                reallySelectedCard.full_name +
                                                    '-' +
                                                    reallySelectedCard.bank_name,
                                            ctx_id: params && Number(params.id),
                                            receiver: selectedUser?.memberId,
                                            name:
                                                selectedUser &&
                                                selectedUser?.name,
                                            interest_pay_mode: values.fee_type,
                                            // as-is, «۱ درصد» would have been
                                            // sent as a rate of 1 — a 100%
                                            // loan. Same bug as the accept
                                            // screen carried.
                                            ...loanInterestFields(
                                                selectedFeeType,
                                                selectedFee
                                            ),
                                            pay_date:
                                                moment().format('YYYY-MM-DD'),
                                            fundName: state?.name,
                                            due_date:
                                                values.date.length > 0
                                                    ? values.date
                                                    : getOneMonthLater(),
                                        }
                                        posthog.capture(
                                            'old_loan_register_started',
                                            {
                                                fund_id: params?.id,
                                                poolship_id: params?.poolShip,
                                            }
                                        )
                                        mutate(data)
                                    } else {
                                        toast.error(
                                            'تعداد اقساط پرداخت شده نمی تواند از تهداد اقساط بیشتر باشد'
                                        )
                                    }
                                } else {
                                    toast.error(
                                        'نحوه دریافت کارمزد را انتخاب کنید'
                                    )
                                }
                            } else {
                                toast.error('میزان کارمزد را وارد کنید')
                            }
                        } else {
                            toast.error('دریافت کننده وام را انتخاب کنید')
                        }
                    } else {
                        toast.error('حداقل مبلغ وام پنج هزار تومان می باشد')
                    }
                }}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form>
                        <div className=" mx-3 flex flex-col h-screen text-sm ">
                            <div className=" grow-0">
                                <Header title="انتقال وام" />
                            </div>
                            <div className=" rounded-lg grow">
                                <div className="  bg-white  mt-14 rounded-lg relative py-4 shadow-[0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]">
                                    <div className=" text-center mt-4">
                                        <img
                                            src={AddNewIcon}
                                            alt="add-loan"
                                            className=" absolute right-[35%] md:right-1/2 md:translate-x-1/2 -top-14"
                                        />
                                    </div>
                                    <div className="  w-full text-center">
                                        <div
                                            dir="rtl"
                                            className="border-b border-dashed border-gray-1"
                                        >
                                            <>
                                                <CustomDatePicker
                                                    setValue={(e: string) => {
                                                        setFieldValue('date', e)
                                                    }}
                                                    name={'date'}
                                                    title="تاریخ اعطای وام"
                                                    placeHolder="تاریخ اعطای وام"
                                                />
                                            </>
                                        </div>
                                        <NumericFormat
                                            customInput={Field}
                                            thousandSeparator
                                            allowNegative={false}
                                            name="amount"
                                            placeholder="مبلغ وام (تومان)"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            value={values.amount}
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue('amount', value)
                                            }}
                                        />

                                        {values.amount !== '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    values.amount.toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                        {errors.amount && touched.amount && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.amount}
                                            </p>
                                        )}

                                        <div
                                            onClick={() =>
                                                setIsOpenReceiver(true)
                                            }
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white"
                                        >
                                            {selectedUser?.name
                                                ? selectedUser?.name
                                                : 'دریافت کننده وام'}
                                        </div>
                                        <div className=" w-full text-center">
                                            <Field
                                                type="text"
                                                inputMode="numeric"
                                                className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3  "
                                                name="number"
                                                placeholder="تعداد اقساط"
                                                min={0}
                                            />
                                            {errors.number &&
                                                touched.number && (
                                                    <p className=" text-sm text-error-3 text-center">
                                                        {errors.number}
                                                    </p>
                                                )}
                                        </div>
                                        <div
                                            onClick={() =>
                                                setIsOpenFeeModal(true)
                                            }
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white"
                                        >
                                            {selectedFee !== undefined &&
                                            selectedFee !== null &&
                                            selectedFee !== 0
                                                ? `${selectedFee} ${
                                                      selectedFeeType ===
                                                      'percentage'
                                                          ? 'درصد'
                                                          : 'تومان'
                                                  }`
                                                : 'میزان کارمزد'}
                                        </div>
                                        {selectedFee !== 0 && (
                                            <Field
                                                name="fee_type"
                                                as="select"
                                                className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            >
                                                <option className="text-gray-1">
                                                    نحوه دریافت کارمزد
                                                </option>
                                                <option value="lip_ma">
                                                    افزودن به هر قسط
                                                </option>
                                                <option value="lip_pr">
                                                    کسر از مبلغ وام
                                                </option>
                                            </Field>
                                        )}
                                        <Field
                                            type="text"
                                            inputMode="numeric"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            placeholder="تعداد اقساط پرداخت شده"
                                            name="paid_loans"
                                            min={0}
                                        />
                                        {errors.paid_loans &&
                                            touched.paid_loans && (
                                                <p className=" text-sm text-error-3 text-center">
                                                    {errors.paid_loans}
                                                </p>
                                            )}
                                        <Field
                                            as="textarea"
                                            name="tag"
                                            className="w-full outline-0 text-center py-4 px-4 text-sm"
                                            placeholder="توضیحات(اختیاری)"
                                        />
                                        {errors.tag && touched.tag && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.tag}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <button
                                className=" grow-0 bg-green-1 text-white py-3 rounded-lg"
                                type="submit"
                            >
                                تایید
                            </button>
                            <button
                                type="button"
                                className=" text-center my-3 text-gray-4"
                                onClick={goBack}
                            >
                                بعدا
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
            <SelectModal
                show={isOpenReceiver}
                onHide={() => setIsOpenReceiver(false)}
                setSelectedUser={setSelectedUser}
                setMemberId={setMemberId}
            />
            <FeeModal
                show={isOpenFeeModal}
                onHide={() => setIsOpenFeeModal(false)}
                setSelectedFee={setSelectedFee}
                setSelectedFeeType={setSelectedFeeType}
            />
        </>
    )
}
